<template>
	<div v-if="context">
		<nk-wrapper
			v-for="(lebenslagen, lebenslagenIndex) in sortedLebenslagen"
			:key="lebenslagenIndex"
			spacing="md"
		>
			<section>
				<nk-title
					:id="`title-${titleId}`"
					:aria-label="`Alle Lebenslagen mit dem Buchstabe ${lebenslagen.letter}`"
					size="lg"
					tag="h1"
					no-margin
				>
					{{ lebenslagen.letter }}
				</nk-title>
				<nk-nav :aria-labelledby="`title-${titleId}`">
					<nk-nav-item
						v-for="(lebenslage, lebenslageIndex) in lebenslagen.children"
						:key="lebenslageIndex"
						:link="lebenslage.detailURL"
					>
						{{ lebenslage.titel }}
					</nk-nav-item>
				</nk-nav>
			</section>
		</nk-wrapper>
	</div>
</template>

<script>
import {groupBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';
import {useId} from '#imports';

export default {
	name: 'NkTemplateWegweiserLebenslagen',

	mixins: [TemplatesDefault],

	setup() {
		const titleId = useId();
		return {titleId};
	},

	computed: {
		sortedLebenslagen() {
			const group = groupBy(this.context, o => o.titel[0].toUpperCase());
			return map(group, (value, key) => ({letter: key, children: value}));
		},
	},
};
</script>
